import React from 'react'
import { Button, Card, Popup } from '@prometheus/components'
import { useSelector } from '../../../../hooks/useSelector'
import { useBossPanelHidden } from '../../hooks/useBossPanelHidden'
import { BossPanelBody } from './BossPanel'
import { BossSprite } from './BossSprites'
import './BossPanel.scss'

/**
 * Where the invasion lives once the panel is hidden: a mothership chip in the
 * header (beside the credit rating) with a mini hull meter. Hover opens the
 * full war room as a popup on desktop; the shared Popup turns that into
 * tap-to-toggle with a dismiss scrim on phones. `hoverable` keeps the popup
 * interactive — the attack form is inside it.
 */
export const BossHeaderChip = () => {
  const boss = useSelector(s => s.game.metadata?.boss)
  const [hidden, setHidden] = useBossPanelHidden()

  if (!boss?.alive || !hidden) {
    return null
  }

  const healthPercent = boss.max_health > 0 ? Math.max(0, Math.min(100, (boss.health / boss.max_health) * 100)) : 0

  return (
    <Card rounded={false} borderColor="none" padding="none" center>
      <Popup
        position="bottom right"
        hoverable
        trigger={(
          <div
            className="pg-boss-chip"
            style={{ '--boss-color': boss.color } as React.CSSProperties}
            role="button"
            aria-label={`${boss.race} invasion — ${Math.round(healthPercent)}% hull`}
          >
            <BossSprite color={boss.color} width={30} />
            <div className="pg-boss-chip__meter">
              <div className="pg-boss-chip__meter-fill" style={{ width: `${healthPercent}%` }} />
            </div>
          </div>
        )}
      >
        {(closePopup) => (
          <div className="pg-boss-pop" style={{ '--boss-color': boss.color } as React.CSSProperties}>
            <BossPanelBody compact />
            <Button
              size="sm"
              variant="dark"
              outline
              onClick={() => { setHidden(false); closePopup() }}
            >
              Show full panel
            </Button>
          </div>
        )}
      </Popup>
    </Card>
  )
}
